(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bike-battery-selector"] && !Shopify.designMode) return;
  try {
    /* Learn-more modal: open / close / escape / backdrop-click.
     The modal is portalled to <body> so no ancestor transforms or
     overflow:hidden ever trap its fixed positioning. */
  (function () {
    function init() {
      var modals = document.querySelectorAll('[data-battery-info-modal]');
      if (!modals.length) return;

      // Move modals to document.body to escape any ancestor containing block.
      modals.forEach(function (modal) {
        if (modal.parentElement !== document.body) {
          document.body.appendChild(modal);
        }
      });

      var opens = document.querySelectorAll('[data-battery-info-open]');
      if (!opens.length) return;

      /* Use the same scroll-lock attribute as the other configurator modals
         (add-on modal, size guide) so simultaneous opens don't stomp each
         other's lock state. */
      function openModal(modal) {
        modal.removeAttribute('inert');
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.documentElement.setAttribute('scroll-lock', '');
      }
      function closeModal(modal) {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        modal.setAttribute('inert', '');
        document.documentElement.removeAttribute('scroll-lock');
      }

      opens.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          openModal(modals[0]);
        });
      });

      modals.forEach(function (modal) {
        modal.querySelectorAll('[data-battery-info-close]').forEach(function (el) {
          el.addEventListener('click', function () { closeModal(modal); });
        });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        modals.forEach(function (modal) {
          if (modal.classList.contains('is-open')) closeModal(modal);
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fixflow-login"] && !Shopify.designMode) return;
  try {
    (function () {
  var modal = document.querySelector('[data-fixflow-login]');
  if (!modal) return;
  var formStage = modal.querySelector('[data-ffl-stage="form"]');
  var pendingStage = modal.querySelector('[data-ffl-stage="pending"]');
  var form = modal.querySelector('[data-ffl-form]');
  var lastFocus = null;

  function open() {
    lastFocus = document.activeElement;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var first = modal.querySelector('input, button');
    if (first) setTimeout(function () { first.focus(); }, 120);
  }
  function close() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    formStage.hidden = false;
    pendingStage.hidden = true;
    if (form) form.reset();
    if (lastFocus) lastFocus.focus();
  }

  document.querySelectorAll('[data-fixflow-login-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) { e.preventDefault(); open(); });
  });
  modal.querySelectorAll('[data-ffl-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
  });

  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    /* Systemet er ikke koblet paa endnu: submit viser den aerlige
       "kontoen foelger med cyklen"-tilstand. Byt denne blok ud med det
       rigtige auth-kald, naar FixFlow-backenden er klar. */
    formStage.hidden = true;
    pendingStage.hidden = false;
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["preorder-popup"] && !Shopify.designMode) return;
  try {
    (function() {
    var popup = document.querySelector('[data-preorder-popup]');
    if (!popup) return;

    var signupEl = popup.querySelector('.po-popup__signup');
    var apiKey = signupEl.getAttribute('data-po-klaviyo-key');
    var listId = signupEl.getAttribute('data-po-klaviyo-list');

    // Launch gating — single source of truth via the countdown's data attributes,
    // which are driven by theme settings (Theme settings → Pre-order popup).
    var countdownRoot = popup.querySelector('[data-po-countdown]');
    var launchTarget = countdownRoot
      ? new Date(countdownRoot.getAttribute('data-launch-iso')).getTime()
      : 0;
    var POST_LAUNCH_URL = (countdownRoot && countdownRoot.getAttribute('data-post-launch-url'))
      || '/products/bycycle-city-u-batches';

    // Reduce any URL to its trailing "/products/<handle>" so a clicked link can
    // be compared against the pre-order product regardless of locale prefix
    // (/da, /de …), query string or hash. This is what makes the gate fire on
    // every translated storefront and independent of the button's wording —
    // the old text match ("pre-order") silently broke once the CTA was
    // translated to "Byg & forudbestil".
    function preorderPath(url) {
      if (!url) return '';
      var a = document.createElement('a');
      a.href = url;
      var m = a.pathname.replace(/\/+$/, '').match(/\/products\/[^\/]+$/);
      return m ? m[0] : '';
    }

    function isLaunched() {
      return launchTarget > 0 && Date.now() >= launchTarget;
    }

    var emailForm = popup.querySelector('[data-po-email-form]');
    var emailInput = popup.querySelector('[data-po-email-input]');
    var errorEl = popup.querySelector('[data-po-error]');
    var nameStep = popup.querySelector('[data-po-name-step]');
    var nameInput = popup.querySelector('[data-po-name-input]');
    var nameSubmit = popup.querySelector('[data-po-name-submit]');
    var nameSkip = popup.querySelector('[data-po-name-skip]');
    var phoneInput = popup.querySelector('[data-po-phone]');
    var phoneCodeInput = popup.querySelector('[data-po-phone-code]');

    // E.164-ish: strip non-digits + leading zeros, prepend country code.
    // Mirrors the Hold-my-bike modal so both feed the same whatsapp_phone field.
    function normalizePhone(raw, code) {
      var local = (raw || '').replace(/\D/g, '').replace(/^0+/, '');
      if (!local) return '';
      return (code || '+45') + local;
    }
    if (phoneCodeInput && phoneInput) {
      phoneCodeInput.addEventListener('change', function() {
        var opt = phoneCodeInput.options[phoneCodeInput.selectedIndex];
        var fmt = opt && opt.getAttribute('data-format');
        if (fmt) phoneInput.setAttribute('placeholder', fmt);
      });
    }
    var successEl = popup.querySelector('[data-po-success]');

    var capturedEmail = '';

    function open() {
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(function() { emailInput.focus(); }, 500);
    }

    function close() {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function reset() {
      emailForm.classList.remove('is-exiting');
      emailForm.removeAttribute('hidden');
      emailForm.querySelector('button[type="submit"]').disabled = false;
      emailInput.value = '';
      errorEl.setAttribute('hidden', '');
      errorEl.textContent = '';
      nameStep.setAttribute('hidden', '');
      nameStep.classList.remove('is-visible');
      nameInput.value = '';
      if (phoneInput) phoneInput.value = '';
      nameSubmit.disabled = false;
      nameSkip.disabled = false;
      successEl.setAttribute('hidden', '');
      capturedEmail = '';
    }

    // Public hook so other UI (e.g. the contact launcher's "Newsletter" button)
    // can open this same signup popup on demand instead of rebuilding the form.
    window.BycycleSignupPopup = { open: function() { reset(); open(); }, close: function() { close(); setTimeout(reset, 500); } };

    popup.querySelectorAll('[data-preorder-close]').forEach(function(el) {
      el.addEventListener('click', function() {
        close();
        setTimeout(reset, 500);
      });
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) {
        close();
        setTimeout(reset, 500);
      }
    });

    function submitToKlaviyo(firstName, phone) {
      var profileAttrs = { email: capturedEmail };
      if (firstName) profileAttrs.first_name = firstName;
      // 🔴 03-09-2026: stod som { pre_order: true, source: 'preorder_popup' }.
      // Ingen af dem var sande: salget er åbent, og pop-uppen er nu
      // nyhedsbrevstilmelding. Et forkert stempel bliver siddende på profilen
      // for evigt og fodrer segmenteringen, saa det er vaerre end forkert tekst.
      // Ingen segmenter filtrerede paa dem (tjekket i Klaviyo samme dag).
      profileAttrs.properties = { newsletter: true, source: 'newsletter_popup' };
      if (phone) {
        profileAttrs.properties.whatsapp_phone = phone;   // eksisterende n8n / WhatsApp-flow, uaendret
        profileAttrs.properties.wants_city_sms = true;    // "sig til naar I er i min by", ikke en lancering
      }

      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(apiKey), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Newsletter popup',
              profile: {
                data: { type: 'profile', attributes: profileAttrs }
              }
            },
            relationships: {
              list: { data: { type: 'list', id: listId } }
            }
          }
        })
      });
    }

    function showSuccess() {
      nameStep.setAttribute('hidden', '');
      successEl.removeAttribute('hidden');
      var texts = successEl.querySelectorAll('p');
      texts.forEach(function(p) { p.style.opacity = '0'; });
      requestAnimationFrame(function() {
        texts[0].style.transition = 'opacity 0.5s ease';
        texts[0].style.opacity = '1';
        if (texts[1]) {
          texts[1].style.transition = 'opacity 0.8s ease 0.3s';
          texts[1].style.opacity = '1';
        }
      });
    }

    emailForm.addEventListener('submit', function(e) {
      e.preventDefault();
      capturedEmail = emailInput.value.trim();
      errorEl.setAttribute('hidden', '');

      if (!apiKey || !listId) {
        errorEl.textContent = 'Signup is not configured yet.';
        errorEl.removeAttribute('hidden');
        return;
      }

      var btn = emailForm.querySelector('button[type="submit"]');
      btn.disabled = true;

      var transitioned = false;
      function revealName() {
        if (transitioned) return;
        transitioned = true;
        emailForm.setAttribute('hidden', '');
        nameStep.removeAttribute('hidden');
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            nameStep.classList.add('is-visible');
            nameInput.focus();
          });
        });
      }

      emailForm.classList.add('is-exiting');
      emailForm.addEventListener('transitionend', function handler(ev) {
        if (ev.propertyName !== 'transform') return;
        emailForm.removeEventListener('transitionend', handler);
        revealName();
      });
      setTimeout(revealName, 700);
    });

    nameSubmit.addEventListener('click', function() {
      var firstName = nameInput.value.trim();
      var phone = phoneInput ? normalizePhone(phoneInput.value, phoneCodeInput ? phoneCodeInput.value : '+45') : '';
      nameSubmit.disabled = true;
      submitToKlaviyo(firstName, phone).then(function(r) {
        if (r.ok || r.status === 202) showSuccess();
        else throw new Error();
      }).catch(function() { showSuccess(); });
    });

    nameSkip.addEventListener('click', function() {
      nameSkip.disabled = true;
      submitToKlaviyo(null).then(function(r) {
        if (r.ok || r.status === 202) showSuccess();
        else throw new Error();
      }).catch(function() { showSuccess(); });
    });

    document.addEventListener('click', function(e) {
      var link = e.target.closest('a');
      if (!link) return;

      // Intercept by DESTINATION, not button label, so the gate works in every
      // language. Any link that resolves to the pre-order product qualifies.
      var targetPath = preorderPath(POST_LAUNCH_URL);
      if (!targetPath || preorderPath(link.href) !== targetPath) return;

      // After launch: skip the popup entirely. Only correct the PATH (e.g. a link
      // without the locale prefix) and keep the link's query and hash: the old
      // override sent every link to the bare URL, so ?look=, ?variant= and utm_*
      // were lost on a real click (measured 29-10-2026 from the Black Month hero).
      // A click another script has already handled is left alone.
      if (isLaunched()) {
        if (e.defaultPrevented) return;
        var dest = new URL(link.href, window.location.href);
        var post = new URL(POST_LAUNCH_URL, window.location.href);
        if (dest.pathname !== post.pathname) {
          e.preventDefault();
          window.location.href = post.pathname + dest.search + dest.hash;
        }
        return;
      }

      e.preventDefault();
      reset();
      open();
    });

    // ---- Countdown ----
    if (countdownRoot && !isNaN(launchTarget)) {
      var els = {
        days:    countdownRoot.querySelector('[data-po-count="days"]'),
        hours:   countdownRoot.querySelector('[data-po-count="hours"]'),
        minutes: countdownRoot.querySelector('[data-po-count="minutes"]'),
        seconds: countdownRoot.querySelector('[data-po-count="seconds"]'),
      };
      var prev = { days: null, hours: null, minutes: null, seconds: null };
      var pad = function(n) { return n < 10 ? '0' + n : '' + n; };

      function tick() {
        var diff = launchTarget - Date.now();
        if (diff <= 0) {
          ['days','hours','minutes','seconds'].forEach(function(k){
            if (els[k] && els[k].textContent !== '00') els[k].textContent = '00';
          });
          countdownRoot.classList.add('is-live');
          // Self-dismiss if the popup is open at the moment of launch.
          if (popup.classList.contains('is-open')) {
            close();
            setTimeout(reset, 500);
          }
          return false;
        }
        var s = Math.floor(diff / 1000);
        var d = Math.floor(s / 86400);
        var h = Math.floor((s % 86400) / 3600);
        var m = Math.floor((s % 3600) / 60);
        var sec = s % 60;
        var next = { days: pad(d), hours: pad(h), minutes: pad(m), seconds: pad(sec) };
        Object.keys(next).forEach(function(k){
          if (next[k] !== prev[k] && els[k]) {
            els[k].textContent = next[k];
            prev[k] = next[k];
          }
        });
        return true;
      }

      if (tick() !== false) {
        var iv = setInterval(function(){
          if (tick() === false) clearInterval(iv);
        }, 1000);
      }
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
